import { FeatureFlag, FeatureFlagConfig } from 'shared/models/feature-flag';

export const FEATURE_FLAG_CONFIG: Record<FeatureFlag, FeatureFlagConfig> = {
  [FeatureFlag.CARE_CONNECT]: {
    id: FeatureFlag.CARE_CONNECT,
    nameKey: 'careConnect.name',
    enabledIn: [
      { environment: 'development', fromVersion: '1.66.0' },
      { environment: 'test', fromVersion: '1.66.0' },
      { environment: 'acceptance', fromVersion: '1.66.0' },
      { environment: 'production', fromVersion: '1.71.0' },
    ],
    disabledIn: [],
  },
  [FeatureFlag.INTERCOM_MAPPINGS]: {
    id: FeatureFlag.INTERCOM_MAPPINGS,
    nameKey: 'intercomMappings.name',
    enabledIn: [
      { environment: 'development', fromVersion: '1.74.0' },
      { environment: 'test', fromVersion: '1.74.0' },
      { environment: 'acceptance', fromVersion: '1.74.0' },
    ],
    disabledIn: ['production'],
  },
};

export function getAllFeatureFlags(): FeatureFlagConfig[] {
  return Object.values(FEATURE_FLAG_CONFIG);
}

export function getFeatureFlagConfig(flag: FeatureFlag): FeatureFlagConfig {
  return FEATURE_FLAG_CONFIG[flag];
}
